import { create } from "zustand";

interface ModalStore {
  shouldOpenSettings: boolean;
  scrollToReleaseNotes: boolean;
  requestOpenSettings: () => void;
  clearOpenSettingsRequest: () => void;
  clearScrollToReleaseNotes: () => void;
}

const useModalStore = create<ModalStore>((set) => ({
  shouldOpenSettings: false,
  scrollToReleaseNotes: false,
  requestOpenSettings: () =>
    set({ shouldOpenSettings: true, scrollToReleaseNotes: true }),
  clearOpenSettingsRequest: () => set({ shouldOpenSettings: false }),
  clearScrollToReleaseNotes: () => set({ scrollToReleaseNotes: false }),
}));

export default useModalStore;
